const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
const Unsupported = require('./unsupported/unsupported')
const Nav = require('module/nav/nav')
const MobileNav = require('module/mobile_nav/mobile_nav')
const Footer = require('module/footer/footer')
const Error404Page = require('page/error/404')
const isAdmin = require('module/viewer/helpers/is_admin')
const radio = require('lib/radio')
const log = require('log').create('app','page')  


class Page extends React.Component {

    constructor(props, context) {
        super(props, context)

        this.toggleMobileNav = this.toggleMobileNav.bind(this)
    }

    componentDidMount() {
        // this.toggleMobileNav() // for debugging
        this.viewport = require('module/viewport/viewport')
        // this.viewport.on('all', log)
        // TODO make sure mobile nav behaves when viewport size changes
        // https://github.com/aboutdotme/main/issues/5466

        this.showCookieNotice()
    }

    showCookieNotice() {
        if (! this.props.show_cookie_notice) return
        require.ensure([], () => {
            const CookieNotice = require('module/cookie_notice/cookie_notice')
            CookieNotice.initialize({
                context: this.context,
            })
        }, 'cookie-banner')
    }

    toggleMobileNav(e) {
        if (! this.viewport.is('small')) return

        if (e) e.preventDefault()

        log('toggleMobileNav')
        // to show/hide the mobile nav, we just need to add/remove
        // the class panel-mobile-nav to the body tag
        // TODO this is storing state as a class on the body
        // see if there's a way to own this state internally
        // and update the body class as a side-effect
        const $ = require('lib/jquery')
        require('jquery-add-prefixed-class')
        if ($.body.hasClass('panel-mobile-nav')) {
            radio.topnav.trigger('hide:mobile:nav')
            $.body.removePrefixedClass('panel', 'mobile-nav')
        } else {
            radio.topnav.trigger('show:mobile:nav')
            $.body.addPrefixedClass('panel', 'mobile-nav')
        }
    }

    renderNav() {
        if (! this.props.render_nav) return null

        return (
            <Nav
                {...this.props.nav_props}
                toggleMobileNav={this.toggleMobileNav}
                />
        )
    }

    renderMobileNav() {
        if (! this.props.render_nav) return null
        return (
            <MobileNav
                {...this.props.nav_props}
                toggleMobileNav={this.toggleMobileNav}
                />
        )
    }

    renderMain() {
        if (! this.props.render_main) return null
        return (
            <main>
                {this.props.children}
            </main>
        )
    }

    renderFooter() {
        if (! this.props.render_footer) return null
        return <Footer />
    }

    renderUnsupported() {
        if (! this.props.render_unsupported) return null
        return <Unsupported />
    }

    render() {
        if (this.props.require_admin) {
            const { viewer } = this.context
            if (! isAdmin(viewer)) {
                return <Error404Page />
            }
        }

        const className = classNames([
            'page-content',
            this.props.className,
        ], {
            'has-footer': this.props.render_footer,
        })

        return (
            <div className={className}>
                {this.renderUnsupported()}
                {this.renderNav()}
                {this.renderMobileNav()}
                {this.renderMain()}
                {this.renderFooter()}
            </div>
        )
    }

}

Page.contextTypes = {
    viewer: PropTypes.object.isRequired,
    page: PropTypes.object.isRequired,
}

Page.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    nav_props: PropTypes.object,
    render_nav: PropTypes.bool,
    render_unsupported: PropTypes.bool,
    render_main: PropTypes.bool,
    render_footer: PropTypes.bool,
    className: PropTypes.string,
    require_admin: PropTypes.bool,
    show_cookie_notice: PropTypes.bool,
}

Page.defaultProps = {
    nav_props: {},
    render_nav: true,
    render_unsupported: true,
    render_main: true,
    render_footer: true,
    require_admin: false,
    show_cookie_notice: true,
}

module.exports = Page
